<template>
  <div v-if="!hide" :class="type" class="btn">
    <a :class="customClass" @click.prevent="getStoryblokLink(link, tab)" v-if="link" :style="style" :href="link.cached_url">
      <div v-if="leftIcon" class="icon-w">
        <fai class="icon left-icon" :icon="leftIcon"></fai>
      </div>
      <span>
        <slot></slot>
      </span>
    </a>
    <router-link :class="customClass" v-else :style="style" :to="path">
      <div v-if="leftIcon" class="icon-w">
        <fai class="icon left-icon" :icon="leftIcon"></fai>
      </div>
      <span>
        <slot></slot>
      </span>
    </router-link>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  props: {
    customClass: {
      type: String,
      default: null
    },
    link: {
      type: Object,
      default: null
    },
    path: {
      type: String,
      default: null
    },
    hide: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: Object,
      default() {
        return {
          backgroundColor: "#5dc0d5"
        };
      }
    },
    leftIcon: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: "19px"
    },
    textColor: {
      type: Object,
      default() {
        return {
          color: "#fff"
        };
      }
    },
    type: {
      type: String,
      default: "inline"
    },
    tab: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ""
    },
    font: {
      type: String,
      default: "inherit"
    }
  },
  computed: {
    style() {
      return {
        fontSize: this.size,
        color: this.textColor.color,
        backgroundColor: this.bgColor.backgroundColor,
        borderColor: "this.textColor",
        width: this.width,
        fontFamily: this.font
      };
    }
  },
  methods: {
    getTarget() {
      return this.tab ? "_blank" : "_self";
    }
  }
};
</script>

<style lang="scss">
.btn {
  a {
    text-decoration: none;
    border-radius: 5px;
    border: none;
    letter-spacing: 1px;
    position: relative;
    z-index: 1;
    cursor: pointer;
    overflow: hidden;
    display: inline-flex;
    flex-wrap: wrap;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.12);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    &:hover {
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15), 0 5px 5px rgba(0, 0, 0, 0.15);
    }
    > * {
      position: relative;
      z-index: 33;
    }
    .icon-w {
      height: 100%;
      position: relative;
      padding: 12px 15px;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.2);
      }
      .icon {
        font-size: 30px;
        position: relative;
        z-index: 1;
      }
    }

    span {
      padding: 12px 25px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@media screen and (max-width: 800px) {
  .btn a {
    span {
      padding: 10px 15px;
      font-size:19px;
    }
    .icon-w {
      padding: 10px;
      .icon {
        font-size: 19px;
      }
    }
  }
}
</style>